import { createContext, useContext } from 'react';
export default function useCommonTreeSelectorContext() {
    return useContext(CommonTreeSelectorContext);
}
export const CommonTreeSelectorContext = createContext({});
